// MissionVision.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/about/MissionSection.css";

const MissionVision = () => {
  return (
    <section className="estatica-mv-section">
      <Container>
        <Row className="g-4 align-items-stretch">

          {/* Mission Card */}
          <Col xs={12} md={6}>
            <div className="estatica-mv-card">
              <span className="estatica-mv-label">Our Mission</span>
              <h2 className="estatica-mv-heading">
                Healthy skin, accessible care.
              </h2>
              <p className="estatica-mv-text">
                To make dermatologist-led skin and laser treatments approachable,
                transparent and tailored to every patient — without compromise
                on safety or results.
              </p>
            </div>
          </Col>

          {/* Vision Card */}
          <Col xs={12} md={6}>
            <div className="estatica-mv-card">
              <span className="estatica-mv-label">Our Vision</span>
              <h2 className="estatica-mv-heading">
                A new standard for skin clinics.
              </h2>
              <p className="estatica-mv-text">
                To set a new benchmark for clinical excellence and patient
                experience — combining medical precision with the warmth of a
                calm, modern environment.
              </p>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default MissionVision;